import RadioCards from "@/common/components/RadioCards";
import { useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { establishmentChoiceEntryOptions } from "../../../../constants/directiveEntryFormSteps/establishmentChoiceEntry/establishmentChoiceEntryOptions.constant";
import { EstablishmentChoiceEntryValidationSchema } from "../../../../schemas/entries/establishmentChoiceEntry.schema";
import { useCreateForwardingsFormStore } from "../../../../stores/createForwardingsFormStore";
import { MaintenanceForwardingsDirectiveFormStepProps } from "../../../../types/maintenanceforwardingsDirectiveFormStep.type";
import { MaintenanceForwardingsDirectiveFromSteps } from "../../../../types/maintenanceForwardingsShowDirectiveDetails.type";
import CreateForwardingDirectiveEntryFormStepAccordion from "../../../CreateForwardingDirectiveEntryFormStepAccordion";
import { MaintenanceForwardingEstablishmentChoiceEntryKlass } from "../../../../types/forwardings/establishmentChoiceEntries/establishmentChoiceEntry.type";

const EstablishmentChoiceEntryFormStepPending = ({
  state,
  attributes,
}: MaintenanceForwardingsDirectiveFormStepProps<MaintenanceForwardingsDirectiveFromSteps.EstablishmentChoiceEntry>) => {
  const {
    control,
    setValue,
  } = useFormContext<EstablishmentChoiceEntryValidationSchema>();

  const { setUpdatedValueAt } = useCreateForwardingsFormStore();

  const {
    establishment_choice_entry_type: watchEstablishmentChoiceEntryType,
  } = useWatch({
    control,
  });

  const EntryOptionComponent = useMemo(() => {
    if (watchEstablishmentChoiceEntryType) {
      const establishmentChoiceOption = establishmentChoiceEntryOptions[watchEstablishmentChoiceEntryType as MaintenanceForwardingEstablishmentChoiceEntryKlass];

      return establishmentChoiceOption.components.pending;
    }

    return null;
  }, [watchEstablishmentChoiceEntryType]);

  return (
    <CreateForwardingDirectiveEntryFormStepAccordion
      state={state}
      title="Método de escolha do estabelecimento"
      body={(
        <div>
          {!watchEstablishmentChoiceEntryType && (
            <RadioCards
              options={
                (attributes as MaintenanceForwardingEstablishmentChoiceEntryKlass[])
                  ?.filter((option) => !!establishmentChoiceEntryOptions[option])
                  ?.map((option) => {
                    const establishmentChoiceOption = establishmentChoiceEntryOptions[option];

                    return {
                      value: option,
                      title: establishmentChoiceOption.title,
                      description: establishmentChoiceOption.description,
                    }
                  })}
              value={watchEstablishmentChoiceEntryType}
              onValueChange={(value) => {
                setUpdatedValueAt();
                setValue('establishment_choice_entry_type', value as MaintenanceForwardingEstablishmentChoiceEntryKlass);
              }}
            />
          )}

          {watchEstablishmentChoiceEntryType && EntryOptionComponent && (
            <EntryOptionComponent />
          )}
        </div>
      )}
    />
  );
}

export default EstablishmentChoiceEntryFormStepPending;
